import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../ui/forms/abstract-visbos-control";
import {IUser} from "../../../../shared/redux-store/session/session.types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {appInjector} from "../../../../index";
import {PasswordChangeValidation} from "./password-change.validator";
import {FORM_ERROR_MESSAGES} from "../../assets/form-error-messages";

@Component({
  selector: 'vb-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => PasswordChangeComponent)}]
})
export class PasswordChangeComponent extends AbstractVisbosControl<IUser, FormGroup> implements OnInit {

  errorDefs = FORM_ERROR_MESSAGES;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: IUser, ...params): FormGroup {
    return PasswordChangeComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      oldPassword: [null],
      password: [null],
      confirmPassword: [null]
    }, {
      validator: PasswordChangeValidation.passwordMatchValidation()
    });

  }

  public setDefaultValues(item?: IUser): { [controlKey: string]: any } | any {
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/password-change/password-change.component.ts